import React, { useState, useCallback } from 'react';
export const UserContext = React.createContext();

const UserProvider = props => {
    const [data, _setData] = useState({});
    const [logged, _setLogged] = useState(false);
    const [hasTransportAvailable, sethasTransportAvailable] = useState(true);
    const [cifs, setCifs] = useState([]);
    const [preferredLocation, _setpreferredLocation] = useState({});
    const [dataP, _setPreferences] = useState({});
    const [buyerType, setBuyerType] = useState(0);
    const [idExpertise, setIdExpertise] = useState({});

    const setUser = useCallback(model => {
        _setData(model);
        //guardarlo en bbdd
    }, []);

    const setLogged = useCallback(isLogged => {
        _setLogged(isLogged);
        //inicializar objeto inicial
    }, []);

    const setPreferences = useCallback(model => {
        _setpreferredLocation(model);
        _setPreferences(model);
    }, []);

    return (
        <UserContext.Provider
            value={{
                user: {
                    data,
                    logged,
                    hasTransportAvailable,
                    cifs,
                    preferredLocation,
                    buyerType,
                    idExpertise,
                },
                preferences: {
                    ...dataP,
                },
                setIdExpertise,
                setLogged: setLogged,
                setUser: setUser,
                setPreferences: setPreferences,
                setCifs,
                setBuyerType,
                sethasTransportAvailable,
            }}
        >
            {props.children}
        </UserContext.Provider>
    );
};

export default UserProvider;
